// lib/hooks/use-button-click.ts
import { useRef } from "react";
import { useKey } from "react-use";
var useButtonClick = (key) => {
  const buttonRef = useRef(null);
  useKey(
    key ?? ((e) => (e.metaKey || e.ctrlKey) && e.key === "Enter"),
    () => {
      buttonRef.current?.click();
    },
    {
      event: "keydown"
    }
  );
  return { buttonRef };
};

export {
  useButtonClick
};
